import {css, StyleDeclaration, CreateSheetWithTheme, useTheme} from 'aphrodite';
import {InterTheme, SpinnerTheme} from './spinner.theme';

export type {SpinnerTheme};

export type SpinnerProps = {
    theme: SpinnerTheme;
    height?: number | '100%';
    strokeWidth?: number;
    styles?: StyleDeclaration;
};

export default function Spinner({theme, height, strokeWidth, styles}: SpinnerProps) {
    const Styles = useTheme(
        {
            ...theme,
            height: height,
        },
        ThemeStyles
    );

    return (
        <div className={css(Styles.spinner, styles)}>
            <svg
                className={css(Styles.svg)}
                viewBox="25 25 50 50"
            >
                <circle
                    className={css(Styles.circle_path)}
                    cx={50}
                    cy={50}
                    r={20}
                    fill="none"
                    strokeWidth={strokeWidth ?? 2}
                    strokeMiterlimit={10}
                />
                <circle
                    className={css(Styles.circle)}
                    cx={50}
                    cy={50}
                    r={20}
                    fill="none"
                    strokeWidth={strokeWidth ?? 2}
                    strokeMiterlimit={10}
                />
            </svg>
        </div>
    );
}

const rotate = {
    '100%': {
        transform: 'rotate(360deg)',
    },
};

const dash = {
    '0%': {
        strokeDasharray: '1, 200',
        strokeDashoffset: 0,
    },
    '50%': {
        strokeDasharray: '89, 200',
        strokeDashoffset: -35,
    },
    '100%': {
        strokeDasharray: '89, 200',
        strokeDashoffset: -124,
    },
};

const ThemeStyles = CreateSheetWithTheme((theme?: InterTheme) => {
    return {
        spinner: {
            height: theme?.height ? theme?.height : undefined,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: theme?.height ? theme?.height : '100%',
            minWidth: theme?.height,
        },
        svg: {
            height: '100%',
            width: '100%',
            display: 'block',
            animationName: rotate,
            animationDuration: '2s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            transformOrigin: '50% 50%',
            WebkitTransformOrigin: '50% 50%',
        },
        circle: {
            animationName: dash,
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'ease-in-out',
            strokeLinecap: 'round',
            stroke: theme?.color,
        },
        circle_path: {
            strokeLinecap: 'round',
            stroke: theme?.pathColor,
        },
    };
});
